import React from 'react'
import {
  OptionWrapper,
  OptionWrapperProps,
} from 'src/editor/layout/sidebar/settings/option-wrapper'
import { Input, InputProps } from 'src/editor/shared/ui-lib/input'

interface TextInputControlProps
  extends Omit<InputProps, 'onChange' | 'onReset' | 'width' | 'className'>,
    OptionWrapperProps {
  update: (value: string) => void
  classNameWrapper?: string
  classNameInput?: string
}

export const TextInputControl = (props: TextInputControlProps) => {
  return (
    <OptionWrapper {...props} className={props.classNameWrapper}>
      <Input
        {...props}
        onChange={props.update}
        className={props.classNameInput}
        width="w-full"
      />
    </OptionWrapper>
  )
}
